import {ASSETS_ROOT} from '../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
import {sanitizeUrl} from '../../../@polygonjs/polygonjs/src/core/UrlHelper';
import type {ExamplesRegisterClass} from '../../engine/examples/ExamplesRegister';
import {docsRoute} from '../../routes';
import {DocsRoute} from '../pages/Pages';
export interface ExampleData {
	name: string;
	label: string;
	thumbnailUrl: string;
	videoUrl: string;
	href: string;
}

export const EXAMPLES_ROOT_URL = sanitizeUrl(`${ASSETS_ROOT}/examples`);

function removeSpaces(word: string): string {
	return word.replace(/ /g, '').replace(/_/g, '');
}
function _thumbnailUrl(exampleName: string) {
	const short = removeSpaces(exampleName).toLowerCase();
	return `${EXAMPLES_ROOT_URL}/${short}/image.webp`;
}
function _videoUrl(exampleName: string) {
	const short = removeSpaces(exampleName).toLowerCase();
	return `${EXAMPLES_ROOT_URL}/${short}/video.mp4`;
}
export function createExampleData(ExamplesRegister: ExamplesRegisterClass, exampleName: string): ExampleData {
	const example = ExamplesRegister.exampleFromName(exampleName);
	if (!example) {
		console.log(`no example found from name`, exampleName);
	}
	const label = example?.label();
	const href = ExamplesRegister.route(exampleName) || docsRoute(DocsRoute.EXAMPLES);
	const data: ExampleData = {
		name: exampleName,
		label: label ? label : exampleName,
		thumbnailUrl: _thumbnailUrl(exampleName),
		videoUrl: _videoUrl(exampleName),
		href: href,
	};
	return data;
}
